
import {Vue, Component, Prop, Emit} from 'vue-property-decorator';
import {USER_AGREEMENT, PRIVACY_POLICY} from './privacy-agreement-text';
import {getDomainHandle} from '@/js/domainUtils';

@Component({
    components: {}
})
export default class PrivacyAgreement extends Vue {
    @Prop({default: false}) value?: boolean;
    visible: boolean = false;
    content: string = '';
    modalTitle: string = '';
    get info() {
        return {
            userAgreement: getDomainHandle('userAgreement'),
            privacyPolicy: '隐私政策'
        };
    }
    onAgree(num: 1 | 2) {
        this.visible = true;
        if (num === 1) {
            this.content = USER_AGREEMENT;
            this.modalTitle = this.info.userAgreement;
        } else {
            this.content = PRIVACY_POLICY;
            this.modalTitle = this.info.privacyPolicy;
        }
    }
    mounted() {}
    created() {}
}
